import React, {useContext, useEffect, useMemo, useRef, useState} from "react";
import {Col, Container, Row} from "react-bootstrap";
import {AgGridReact} from "ag-grid-react";
import useWindowDimensions from "hooks/Dimensions";
import {AssetTransferContext} from "./context";
import { dateToString,
    formatDateString,
    stringToDate,
    yearMonthDayToPickerDateFormat} from "utils/FormatUtils";
import {useHistory, useLocation} from 'react-router-dom';
import {
    cellAlignment, cellStyleCheckerStatusError,
    numberFormat3FractionalDigits,
    numberFormat5FractionalDigits,
    numberFormatter
} from "utils/NumberUtils";
import {
    DEFAULT_GRID_PAGINATION_SIZE,
    ENABLE_SCROLL_BUTTONS_PAGINATION_SIZE,
    GRID_COLUMN_PROPERTY
} from "utils/Constants";
import * as Routes from "routes/Routes";
import {addPropertiesToGridColumns, getDisplayedNumberOfGridRows} from "../../utils/gridColumnUtils";
import {UtilsContext} from "../../context/utils";
import ScrollButton from "../../components/AgGridToolbar/ToolBarButtons/ScrollButton";
export default function AssetTransferEntryResult() {
    const {showButton, setShowButton} = useContext(UtilsContext);
    const [gridApi, setGridApi] = useState(null);
    const {assetTransferCaptureDisplayState, setAssetTransferCaptureDisplayState, setViewClicked, getRowStyle} = useContext(AssetTransferContext);
    const [rowData, setRowData] = useState([]);
    const {isMobile} = useWindowDimensions();

    const myGrid = useRef(null);
    const location = useLocation();
    let history = useHistory();

    function navigateToPage(path) {
        history.push(path);
    }
    const cellStyleChecker = (param) => {

        if (typeof param === 'string' && param.length > 0) {
            return {backgroundColor: '#ce7c7c', color: '#6e0c01'};
        }
        return {};
    }
    const cellStyleCheckerCellAlignRight = (param) => {

        if (typeof param === 'string' && param.length > 0) {
            return {backgroundColor: '#ce7c7c', color: '#6e0c01',textAlign: 'right'};
        }
        return {textAlign: 'right'};
    }

    const messageToErrors = (message) => {
        // message split by .
        if (message === undefined || message === null || message.length === 0) {
            return {};
        }
        const preErrors = message.split('.').map((msg) => msg.trim()).filter((msg) => msg.length > 0);
        let j =0
        let fieldsList = []
        let dataList = []
        for (let i = 0; i < preErrors.length; i++) {
            // find - in current string
            const index = preErrors[i].indexOf('-');
            if (index !== -1) {
                const field =  preErrors[i].substring(0,index).trim();
                const value =  preErrors[i].substring(index + 1).trim();
                if (field) {
                    fieldsList.push(field)
                    dataList.push(value);
                    j = j+1
                }
            } else {
                // no field found, just add the message
                dataList[j] = dataList[j] + ' ' + preErrors[i].trim();
            }
        }
        let errors = {}
        for (let i = 0; i < j; i++) {
            errors[fieldsList[i]] = dataList[i];
        }
        return errors;
    }


    useEffect(() => {
        assetTransferCaptureDisplayState.currentPage = ""
    }, [location])


    useEffect(() => {
        let rows = []
        rows.push(assetTransferCaptureDisplayState['assetTransferEntry']['resData'])

        if (rows && rows.length > 0) {
            for (let item of rows) {
                if (item.comment && item.comment.length > 0) {
                    const errors = messageToErrors(item.comment);
                    item['errFromComments'] = errors;
                }
            }
        }

        setRowData(rows);
    }, [assetTransferCaptureDisplayState])

    const defaultColDef = {
        sortable:true,
        resizable:true,
        floatingFilter:true,
        filter:true,
        enableCellChangeFlash:true,
        lockPinned:!!isMobile,
    };

    const columnDefs = [
        {headerName: 'View', field:'', cellRenderer: "viewCellRenderer"},
        {headerName: '', field:'indAssetTranferCancel', hide:true, suppressColumnsToolPanel:true},
        {headerName: 'Request Id', field: 'requestId'},
        {headerName: 'Status', field: 'uiStatus'},
        {headerName: 'Customer Reference Number', field: 'custRefNum',tooltipValueGetter: params => params.data.errFromComments && params.data.errFromComments['custRefNum'],
        cellStyle: (params) => cellStyleChecker(params.data.errFromComments && params.data.errFromComments['custRefNum'])},
        {headerName: 'Category', field: 'category',tooltipValueGetter: params => params.data.errFromComments && params.data.errFromComments['category'],
            cellStyle: (params) => cellStyleChecker(params.data.errFromComments && params.data.errFromComments['category'])},
        {headerName: 'Long/Short/Cash', field: 'accountType', cellRenderer: "accountTypeResultRenderer",tooltipValueGetter: params => params.data.errFromComments && params.data.errFromComments['accountType'],
            cellStyle: (params) => cellStyleChecker(params.data.errFromComments && params.data.errFromComments['accountType'])},
        {headerName: 'Instruction Type', field: 'instructionType',tooltipValueGetter: params => params.data.errFromComments && params.data.errFromComments['instructionType'],
            cellStyle: (params) => cellStyleChecker(params.data.errFromComments && params.data.errFromComments['instructionType'])},
        {headerName: 'Broker MPID', field: 'brokerMpidId',tooltipValueGetter: params => params.data.errFromComments && params.data.errFromComments['brokerMpidId'],
            cellStyle: (params) => cellStyleChecker(params.data.errFromComments && params.data.errFromComments['brokerMpidId'])},
        {headerName: 'CPTY Account Number', field: 'cptyAccountNumber',tooltipValueGetter: params => params.data.errFromComments && params.data.errFromComments['cptyAccountNumber'],
            cellStyle: (params) => cellStyleChecker(params.data.errFromComments && params.data.errFromComments['cptyAccountNumber'])},
        {headerName: 'Security Id', field: 'srcSecCd',tooltipValueGetter: params => params.data.errFromComments && params.data.errFromComments['srcSecCd'],
            cellStyle: (params) => cellStyleChecker(params.data.errFromComments && params.data.errFromComments['srcSecCd'])},
        {headerName: 'Manager', field: 'manager'},
        {headerName: 'Trade Date', field: 'tradeDate', valueGetter: (params) => stringToDate(dateToString(params.data.tradeDate)),tooltipValueGetter: params => params.data.errFromComments && params.data.errFromComments['tradeDate'],
            cellStyle: (params) => cellStyleChecker(params.data.errFromComments && params.data.errFromComments['tradeDate'])},
        {headerName: 'Settlement Date', field: 'settleDate', valueGetter: (params) => stringToDate(dateToString(params.data.settleDate)),tooltipValueGetter: params => params.data.errFromComments && params.data.errFromComments['settleDate'],
            cellStyle: (params) => cellStyleChecker(params.data.errFromComments && params.data.errFromComments['settleDate'])},
        {headerName: 'Settlement Location', field: 'settleLocation',tooltipValueGetter: params => params.data.errFromComments && params.data.errFromComments['settleLocation'],
            cellStyle: (params) => cellStyleChecker(params.data.errFromComments && params.data.errFromComments['settleLocation'])},
        {headerName: 'Settlement Currency', field: 'settleCurrency',tooltipValueGetter: params => params.data.errFromComments && params.data.errFromComments['settleCurrency'],
            cellStyle: (params) => cellStyleChecker(params.data.errFromComments && params.data.errFromComments['settleCurrency'])},
        {headerName: 'Settlement Quantity', field: 'settleQuantity', valueFormatter: numberFormatter,tooltipValueGetter: params => params.data.errFromComments && params.data.errFromComments['settleQuantity'],
            cellStyle: (params) => cellStyleChecker(params.data.errFromComments && params.data.errFromComments['settleQuantity'])},
        {headerName: 'Settlement Amount', field: 'settleAmount', valueFormatter: numberFormat3FractionalDigits,tooltipValueGetter: params => params.data.errFromComments && params.data.errFromComments['settleAmount'],
            cellStyle: (params) => cellStyleCheckerCellAlignRight(params.data.errFromComments && params.data.errFromComments['settleAmount'])},
        {headerName: 'DTC Number', field: 'dtcNumber',tooltipValueGetter: params => params.data.errFromComments && params.data.errFromComments['dtcNumber'],
            cellStyle: (params) => cellStyleChecker(params.data.errFromComments && params.data.errFromComments['dtcNumber'])},
        {headerName: 'DTC Account Number', field: 'dtcAcctNumber',tooltipValueGetter: params => params.data.errFromComments && params.data.errFromComments['dtcAcctNumber'],
            cellStyle: (params) => cellStyleChecker(params.data.errFromComments && params.data.errFromComments['dtcAcctNumber'])},
        {headerName: 'FED Delivery Instruction', field: 'fedInstruction',tooltipValueGetter: params => params.data.errFromComments && params.data.errFromComments['fedInstruction'],
            cellStyle: (params) => cellStyleChecker(params.data.errFromComments && params.data.errFromComments['fedInstruction'])},
        {headerName: 'Additional Information', field: 'additionalInfo',tooltipValueGetter: params => params.data.errFromComments && params.data.errFromComments['additionalInfo'],
            cellStyle: (params) => cellStyleChecker(params.data.errFromComments && params.data.errFromComments['additionalInfo'])},
        {headerName: 'Comments', field: 'comment'}
    ];

    const updatedColumnDefs = useMemo(() => addPropertiesToGridColumns(columnDefs, GRID_COLUMN_PROPERTY), []);

    const onViewClicked = (props) => {
        const newAssetTransferState = JSON.parse(JSON.stringify(assetTransferCaptureDisplayState));
                newAssetTransferState.assetTransferEntry.accountId	=	props.accountId
                newAssetTransferState.assetTransferEntry.additionalInfo	=	props.additionalInfo
                newAssetTransferState.assetTransferEntry.comment	=	props.comment
                newAssetTransferState.assetTransferEntry.custRefNum	=	props.custRefNum
                newAssetTransferState.assetTransferEntry.dtcAcctNumber	=	props.dtcAcctNumber
                newAssetTransferState.assetTransferEntry.dtcNumber	=	props.dtcNumber
                newAssetTransferState.assetTransferEntry.fedInstruction	=	props.fedInstruction
                newAssetTransferState.assetTransferEntry.instructionType	=	props.instructionType
                if (props.accountType !==null && props.accountType !== undefined) {
                    newAssetTransferState.assetTransferEntry.accountType	=	"" + props.accountType
                }
                newAssetTransferState.assetTransferEntry.manager	=	props.manager
                newAssetTransferState.assetTransferEntry.settleQuantity	=	props.settleQuantity
                newAssetTransferState.assetTransferEntry.requestId	=	props.requestId
                newAssetTransferState.assetTransferEntry.id	=	props.id
                newAssetTransferState.assetTransferEntry.requestType	=	props.requestType
                newAssetTransferState.assetTransferEntry.srcSecCd	=	props.srcSecCd
                newAssetTransferState.assetTransferEntry.settleAmount	=	props.settleAmount
                newAssetTransferState.assetTransferEntry.settleCurrency	=	props.settleCurrency
                newAssetTransferState.assetTransferEntry.settleDate	=	props.settleDate ? yearMonthDayToPickerDateFormat(props.settleDate.toString()) : ''
                newAssetTransferState.assetTransferEntry.settleLocation	=	props.settleLocation
                newAssetTransferState.assetTransferEntry.status	=	props.status
                newAssetTransferState.assetTransferEntry.uiStatus	=	props.uiStatus
                newAssetTransferState.assetTransferEntry.tradeDate	=	props.tradeDate ? yearMonthDayToPickerDateFormat(props.tradeDate.toString()) : ''
                newAssetTransferState.assetTransferEntry.category	=	props.category
                newAssetTransferState.assetTransferEntry.brokerMpidId	=	props.brokerMpidId
                newAssetTransferState.assetTransferEntry.cptyAccountNumber	=	props.cptyAccountNumber

                setAssetTransferCaptureDisplayState(newAssetTransferState)
                setViewClicked(true)
    }

    const viewCellRenderer = function (props){
        return (<>
            {
                <a className="td-link" href="#" onClick={() => {
                    onViewClicked(props.data);
                    navigateToPage(Routes.ASSERTTRANSFER_ENTRY + "/" + props.data.status)
                }}>View</a>
            }
        </>);
    }

    const accountTypeResultRenderer = function (props){
        return(<>
            {props.data.accountType===2 ? 'Long' : props.data.accountType===5 ? 'Short' : props.data.accountType===1?'Cash':''}
        </>);
    }
    const onDataRendered = (params) => {
        setShowButton(getDisplayedNumberOfGridRows(gridApi) >= ENABLE_SCROLL_BUTTONS_PAGINATION_SIZE);
    }

    const onPaginationChange = (params) => {
        setShowButton(getDisplayedNumberOfGridRows(gridApi) >= ENABLE_SCROLL_BUTTONS_PAGINATION_SIZE);
    }
    const onGridReady = (params) => {
        setGridApi(params.api);
    }

    return(<>
        <Container fluid>
            <Row className="justify-content-start navbar py-4">
                <Col xs={12} className="pl-2">
                    <h1>
                        Asset Transfer Entry Result
                    </h1>
                </Col>
            </Row>
            <div
                ref={myGrid}
                id="myGrid"
                className="ag-theme-alpine ag-grid-block">
                <AgGridReact
                    frameworkComponents={{
                        viewCellRenderer:viewCellRenderer,
                        accountTypeResultRenderer: accountTypeResultRenderer
                    }}
                    paginationPageSize={DEFAULT_GRID_PAGINATION_SIZE}
                    groupDefaultExpanded={'1'}
                    enableRowGroup={false}
                    suppressDragLeaveHidesColumns={true}
                    suppressMakeColumnVisibleAfterUnGroup={true}
                    suppressModelUpdateAfterUpdateTransaction={true}
                    suppressScrollOnNewData={true}
                    suppressAggFuncInHeader={true}
                    allowShowChangeAfterFilter={false}
                    rowGroupPanelShow={'never'}
                    enableSorting={true}
                    enableFilter={true}
                    pagination={true}
                    defaultColDef={defaultColDef}
                    columnDefs={updatedColumnDefs}
                    rowData={rowData}
                    animateRows={true}
                    onGridReady={onGridReady}
                    onFirstDataRendered={onDataRendered}
                    onPaginationChanged={onPaginationChange}
                    getRowStyle={getRowStyle}
                >
                </AgGridReact>
            </div>
        </Container>
        {showButton && <ScrollButton showButton={showButton}/>}

    </>);

}
